import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon ionic-ios-arrow-forward",
  "use": "icon-Icon ionic-ios-arrow-forward-usage",
  "viewBox": "0 0 5.403 9.45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5.403 9.45\" id=\"icon-Icon ionic-ios-arrow-forward\">\r\n  <path id=\"icon-Icon ionic-ios-arrow-forward_Icon_ionic-ios-arrow-forward\" data-name=\"Icon ionic-ios-arrow-forward\" d=\"M15.021,10.92,11.445,7.346a.672.672,0,0,1,0-.954.681.681,0,0,1,.957,0l4.052,4.049a.674.674,0,0,1,.02.931L12.4,15.45a.675.675,0,0,1-.957-.954Z\" transform=\"translate(-11.246 -6.196)\" fill=\"#1947a3\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol